  import { jsx as _jsx } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Function that renders the final JSX of the component
 */ export const renderAccordionPanel_unstable = (state)=>{
    assertSlots(state);
    return state.open ? /*#__PURE__*/ _jsx(state.root, {
        children: state.root.children
    }) : null;
};
